import { z } from "zod";

import { addressSchema } from "@schemas/misc";

/**
 * schemas
 */

export const GetDelegateAddressRequestSchema = z.object({
  chainId: z.number(),
});
export type GetDelegateAddressRequest = z.infer<
  typeof GetDelegateAddressRequestSchema
>;

export const getDelegateAddressResponseSchema = z.object({
  otimDelegateAddress: z.string(),
});
export type GetDelegateAddressResponse = z.infer<
  typeof getDelegateAddressResponseSchema
>;

export const getConfigTokensRequestParametersSchema = z.object({
  chainId: z.number(),
});
export type GetConfigTokensRequestParameters = z.infer<
  typeof getConfigTokensRequestParametersSchema
>;

export const getConfigTokensResponseSchema = z.object({
  tokens: z.array(z.object({ symbol: z.string(), address: addressSchema })),
});
export type GetConfigTokensResponse = z.infer<
  typeof getConfigTokensResponseSchema
>;

export const getConfigChainsResponseSchema = z.object({
  chains: z.array(z.object({ chainId: z.number(), chainName: z.string() })),
});
export type GetConfigChainsResponse = z.infer<
  typeof getConfigChainsResponseSchema
>;

export const getInstructionStorageAddressRequestSchema = z.object({
  chainId: z.number(),
});
export type GetInstructionStorageAddressRequest = z.infer<
  typeof getInstructionStorageAddressRequestSchema
>;

export const getInstructionStorageAddressResponseSchema = z.object({
  address: addressSchema,
});
export type GetInstructionStorageAddressResponse = z.infer<
  typeof getInstructionStorageAddressResponseSchema
>;

export const getHealthResponseSchema = z.object({
  "otim.db.liveness": z.boolean(),
});
export type GetHealthResponse = z.infer<typeof getHealthResponseSchema>;
